import "./index.scss";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
function kernalModule({}) {
  const history = useHistory();
  const { t } = useTranslation();
  const language = localStorage.getItem("i18nextLng");
  const kernalModuleContent = t("spaceOperations.space_part3", {
    returnObjects: true,
  });
  const clickTo = (type) => {
    history.push(`/solution/KernelModulePage?type=${type}`);
  };
  return (
    <div className="kernalModule">
      <div className="edition_solution edition_solution_top">
        <div className="edition_solution_title">
          <div className="kernalModule_title">{kernalModuleContent.title}</div>
          <span className="kernalModule_subhead">
            {kernalModuleContent.subhead}
          </span>
        </div>
      </div>
      <div className="kernalModule_con">
        {kernalModuleContent.space_part3List.map((item0, index0) => {
          return (
            <div
              className="kernalModule_li"
              key={index0}
              style={
                language === "zh" ? { height: "420px" } : { height: "465px" }
              }
            >
              <div
                className="kernalModule_li_img"
                style={{
                  background: `url(${item0.imgUrl}) no-repeat center center`,
                }}
              >
                {/* <div className="kernalModule_li_icon"></div> */}
                {/* <img src={item0.imgUrl} alt="" style={{width:'100%'}}/> */}
              </div>
              <div className="kernalModule_li_content">
                <div
                  className="kernalModule_li_til"
                  style={
                    language === "zh"
                      ? { fontSize: "26px" }
                      : { fontSize: "20px" }
                  }
                >
                  {item0.itemTitle}
                </div>
                <div
                  className="kernalModule_li_con"
                  style={
                    language === "zh"
                      ? { fontSize: "16px" }
                      : { fontSize: "14px", height: "110px" }
                  }
                >
                  {item0.itemContent}
                </div>
                <span
                  className="kernalModule_li_more"
                  onClick={() => clickTo(item0.type)}
                >
                  {kernalModuleContent.learn_more}
                  {"->"}
                </span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default kernalModule;
